import {
  paginationStyle,
  audienceBulkAssociationStyle,
  audienceModalStyles,
  audienceExpressionStyle,
  kendoMultiSelectStyle,
  audienceCombinedListStyle,
  labelPopupStyle,
  labelColumnHeaderStyle,
  getFluctuationGridCellStyle,
  getFluctuationLoadingStyle,
  getFluctuationTooltipStyle,
  getBudgetCenterTooltipStyle,
  qualityScorePopupStyle,
  entitySelectorStyle,
  campaignGridBudgetCenterEntryStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { cashbackPercentGridCommonStyle } from '@bingads-webui-campaign/personalized-offer-columns';
import { gridFlexStyle } from '@bingads-webui-campaign-react/grid-flex-style';
import {
  adEditorOverrideStyle,
} from '@bingads-webui-campaign-react/ad-editor-styles';
import { inlineChartContainerStyle } from '@bingads-webui-campaign-react/inline-chart-style';
import { pagePaddingStyle } from '@bingads-webui-campaign-react/page-padding-style';

export const getTopGridPanelCustomStyles = (_, palette) => (
  Object.assign(
    {},
    {
      '& .previewTable tr > td': {
        maxWidth: '512px',
        wordBreak: 'normal',
        overflowWrap: 'anywhere',
      },
      '& .top-panel-cashback-settings': {
        '& .bidding-strategy-form': {
          marginTop: 12,
          '& .col-sm-6': {
            boxSizing: 'content-box',
            paddingTop: 5,
            '& > .form-control-static': {
              paddingBottom: 8,
              minHeight: 1,
            },
          },
          '& select': {
            margin: '5px 0',
            width: 460,
          },
          '& div[data-bind="visible: checkCPC"]': {
            paddingTop: 8,
          },
          '& input[type="checkbox"]': {
            float: 'left',
          },
          '& .custom-param__key-field': {
            display: 'inline-block',
            width: 85,
            marginLeft: 5,
            marginRight: 5,
          },
          '& #currencyLabelTargetCpa': {
            display: 'inline-block',
            'vertical-align': 'initial',
            marginTop: 0,
          },
          '& #currencyLabelTargetRoas': {
            display: 'inline-block',
            'vertical-align': 'initial',
            marginTop: 0,
          },
          '& #currencyLabelCostPerSale': {
            display: 'inline-block',
            'vertical-align': 'initial',
            marginTop: 0,
          },
          '& .alert.alert-info': {
            marginTop: 8,
          },
          '& a.helpbutton': {
            'margin-left': '5px',
          },
        },
        '& .enable-po-checkbox-container, .cashback-settings, .bidding-strategy-form': {
          '& .checkbox-inline .text': {
            display: 'inline',
          },
          '& .col-sm-2, .col-sm-4, .col-sm-8, .col-sm-12, .col-sm-6': {
            float: 'none',
            paddingLeft: 'unset',
            paddingRight: 'unset',
          },
          '& .alert-div': {
            width: '50%',
          },
          '& .control-label': {
            width: 'auto',
          },
          '& .col-sm-4': {
            width: 'auto',
          },
          '& label': {
            display: 'inline-block',
          },
          '& label.checkbox-inline': {
            width: '300px',
          },
          '& .po-switch-container .HelpTopic': {
            marginLeft: '5px',
            textDecoration: 'underline',
          },
          '& .form-group': {
            '& .control-label': {
              fontSize: 14,
              display: 'block',
            },
            '& .input-group-addon': {
              width: 'auto',
            },
          },
          '& .cashback-budget-cap-input': {
            width: 168,
          },
          '& .cashback-percent-input': {
            width: 66,
            display: 'inline-block',
            marginRight: 0,
          },
          '& .cashback-option-select': {
            width: 180,
            display: 'inline-block',
            marginRight: 10,
          },
        },
      },

      '& .add_icon.spritedimage::before': {
        content: '"\\E710"',
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: 15,
        verticalAlign: 'middle',
        marginRight: '5px',
        cursor: 'pointer',
      },
    },
    audienceBulkAssociationStyle({ palette }),
    paginationStyle({ palette })
  )
);

export const getCampaignsGridViewStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  inlineChartContainer: inlineChartContainerStyle(palette),
  topGridPanelCustomStyles: getTopGridPanelCustomStyles(_, palette),
  '@global': Object.assign(
    {
      '.optimization_score_with_popover': {
        borderBottom: '1px dashed #0078D4',
        minWidth: 15,
      },
      '.performance-insights-status': {
        justifyContent: 'center',
        backgroundColor: '#F0F0F0',
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        height: 24,
        borderRadius: 19,
        paddingLeft: 8,
        paddingRight: 8,
        columnGap: 6,
        cursor: 'pointer',
      },
      '.performance-insights-null-status': {
        display: 'flex',
      },
      '.toolbar-container #button-campaign-create .iconba.iconba-Add': {
        marginTop: -4,
      },
      '.ms-Callout-container .import-from-google': {
        minWidth: 202,
      },
      '#bulkEditContainer input[type="checkbox"]': {
        float: 'left',
        bottom: '0px',
      },
      '.recommendation-new-ads-inline-view': {
        ...adEditorOverrideStyle({ palette }),
      },
      '.campaign-tab-grid': {
        ...getFluctuationGridCellStyle({ palette }),
        '& .cashback-budget-container': {
          wordBreak: 'break-all',
        },
      },
      '.campaign-creation-success-dialog': {
        '& .modal-content': {
          width: 600,
          '& .modal-header': {
            '& button': {
              zIndex: 1,
            },
          },
          '& .modal-body': {
            marginTop: -62,
            '& .success-dialog__header': {
              '& h2': {
                fontSize: 20,
              },
            },
            '& .success-dialog__content': {
              margin: '24px 0',
              '& .content-line': {
                fontSize: 14,
                fontWeight: 'normal',
                margin: '10.5px 0',
                display: 'block',
              },
              '@media screen and (-ms-high-contrast: active), (forced-colors: active)': {
                '& .campaign-creation-status-icon-active, .horizontal-line-success, .campaign-creation-status-text-active': {
                  color: 'highlight !important',
                },
              },
              '& .dialog-diagram': {
                marginTop: 15,
                '& .dialog-diagram__bar': {
                  width: '100%',
                  textAlign: 'center',
                  '& .campaign-creation-status-icon-active': {
                    fontFamily: iconFontFamily,
                    color: palette.green,
                    '&:before': {
                      content: '"\\E920"',
                    },
                  },
                  '& .campaign-creation-status-icon-warning': {
                    fontFamily: iconFontFamily,
                    color: palette.neutralPrimary,
                    '&:before': {
                      content: '"\\E920"',
                    },
                  },
                  '& .campaign-creation-status-icon-danger': {
                    fontFamily: iconFontFamily,
                    color: '#A80000',
                    '&:before': {
                      content: '"\\EB90"',
                    },
                  },
                  '& .campaign-creation-status-icon-inactive': {
                    fontFamily: iconFontFamily,
                    color: palette.neutralSecondary,
                    '&:before': {
                      content: '"\\E920"',
                    },
                  },
                  '& .horizontal-line-1of3rd': {
                    display: 'inline-block',
                    width: 150,
                    margin: '5px -1px',
                    border: `1px solid ${palette.neutralSecondary}`,
                  },
                  '& .horizontal-line-1of2rd': {
                    display: 'inline-block',
                    width: 225,
                    margin: '5px -1px',
                    border: `1px solid ${palette.neutralSecondary}`,
                  },
                  '& .horizontal-line-success': {
                    borderColor: palette.green,
                  },
                },
                '& .dialog-diagram__row': {
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  '& .dialog-diagram__row__cell': {
                    flex: '0 0 auto',
                    display: 'inline-block',
                    width: 100,
                    textAlign: 'center',
                    fontSize: 12,
                  },
                  '& .campaign-creation-status-text-active': {
                    color: palette.green,
                  },
                  '& .campaign-creation-status-text-warning': {
                    color: palette.neutralPrimary,
                  },
                  '& .campaign-creation-status-text-danger': {
                    color: '#A80000',
                  },
                },
              },
              '& .dialog-form': {
                marginTop: 20,
                '& .btn': {
                  lineHeight: '28px',
                },
              },
            },
          },
        },
      },
      '.doubleListBoxContainer.association__create': {
        width: '99%',
      },
      ...campaignGridBudgetCenterEntryStyle({ palette }),
    },
    pagePaddingStyle(),
    cashbackPercentGridCommonStyle({ palette }),
    qualityScorePopupStyle(),
    gridFlexStyle({ palette }),
    labelPopupStyle({ palette }),
    labelColumnHeaderStyle(),
    audienceModalStyles({ palette }),
    audienceExpressionStyle(),
    audienceCombinedListStyle({ palette }),
    kendoMultiSelectStyle({ palette }),
    getFluctuationLoadingStyle(),
    getFluctuationTooltipStyle(),
    getBudgetCenterTooltipStyle(),
    entitySelectorStyle({ palette }),
    paginationStyle({ palette })
  ),
});

